import { ProsperaOrganType, TestType } from "@app/provider/testData/types";
import { atUtcMidnight } from "./convertDate";

const PROSPERA_EBDD_ORGANS = [ProsperaOrganType.HEART, ProsperaOrganType.LUNG];

type EbddSource = {
  testType?: TestType;
  organType?: ProsperaOrganType | null;
  resultExpectedByDate?: Date | string | null;
};

/** The EBDD that Prospera Heart/Lung draws are pinned to, if this order has one. */
export const getProsperaEbdd = ({
  testType,
  organType,
  resultExpectedByDate,
}: EbddSource): Date | undefined => {
  if (
    testType !== TestType.PROSPERA ||
    !organType ||
    !PROSPERA_EBDD_ORGANS.includes(organType) ||
    !resultExpectedByDate
  ) {
    return undefined;
  }
  const ebdd = new Date(resultExpectedByDate);
  return isNaN(ebdd.getTime()) ? undefined : ebdd;
};

export const hasProsperaEbddPassed = (
  source: EbddSource,
  now = new Date()
): boolean => {
  const ebdd = getProsperaEbdd(source);
  return !!ebdd && atUtcMidnight(ebdd).getTime() < atUtcMidnight(now).getTime();
};
